import React from 'react'

const VerticalDotsIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_280_3406)'>
        <path
          d='M12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z'
          stroke='#735BF2'
          strokeWidth='1.5'
          strokeMiterlimit='10'
        />
        <path
          d='M12 6.75C13.2426 6.75 14.25 5.74264 14.25 4.5C14.25 3.25736 13.2426 2.25 12 2.25C10.7574 2.25 9.75 3.25736 9.75 4.5C9.75 5.74264 10.7574 6.75 12 6.75Z'
          stroke='#735BF2'
          strokeWidth='1.5'
          strokeMiterlimit='10'
        />
        <path
          d='M12 21.75C13.2426 21.75 14.25 20.7426 14.25 19.5C14.25 18.2574 13.2426 17.25 12 17.25C10.7574 17.25 9.75 18.2574 9.75 19.5C9.75 20.7426 10.7574 21.75 12 21.75Z'
          stroke='#735BF2'
          strokeWidth='1.5'
          strokeMiterlimit='10'
        />
      </g>
      <defs>
        <clipPath id='clip0_280_3406'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default VerticalDotsIcon
